import {viewModel} from "@/class/view-model";
import store from "@/store/store";
import {Media} from "@/class/data-type";

export class contentPage extends viewModel{
    
    objectType = "content_page";
    
    /**
     * variables de données
     */
    data = [
        {name: "title", type: String, default: ""},
        {name: "teaser", type: String, default: ""},
        {name: "thumbnail", type: Media, default: new Media({type:"picture"})},
    ]
    
    constructor() {
        super();
        this.init()
    }
    
    getName(){
        return this.title;
    }
    getThumbnail(){
        return this.thumbnail.media || store.getters.getDefault("BaseImage");
    }
}